<div mat-dialog-title class="actions" fxLayout="row" fxLayoutAlign="end center">
  <h2 fxFlex>Visor de pedidos</h2>
  <button mat-icon-button (click)="downloadPdf()" tabindex="-1"><mat-icon>file_download</mat-icon></button>
  <button mat-icon-button (click)="openPdf()" tabindex="-1"><mat-icon>open_in_new</mat-icon></button>
  <button mat-icon-button (click)="close()" tabindex="-1"><mat-icon>close</mat-icon></button>
</div>
<div mat-dialog-content>
  <div #pdfViewer class="pdf-container" fxFlex>
    <pdf-viewer [src]="pdfSrc" [render-text]="true" [autoresize]="true" (after-load-complete)="updateViewer()"
      style="display: block;" class="pdf-view"></pdf-viewer>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="close()" tabindex="-1">Cerrar</button>
</div>